import * as superagent from "superagent";
import {config} from "../../config";
import {CurrencyDenominator} from "../CurrencyDenominator";
import {InfoModal} from "../InfoModal";
import {DiceBet} from "./DiceBet";
import {AccountInfo} from "./serverResponseClasses/AccountInfo";
import {ServerResponse} from "./serverResponseClasses/ServerResponse";

export class ApiService {

    private readonly STEEM_ACCOUNT_NAME: string = "steemaccountname";
    private readonly STEEM_CONNECT_TOKEN: string = "steemconnecttoken";
    private readonly KEYCHAIN_JWT: string = "keychainjwt";

    private steemAccountName: string;
    private steemConnectToken: string;
    private keychainJWT: string;

    constructor() {
    }

    public getGameResult(diceBet: DiceBet, betCurrency: string): Promise<ServerResponse> {
        diceBet.betAmount = CurrencyDenominator.ToBase(diceBet.betAmount);
        return superagent
            .post(config.gameServerAddress + "/getGameResult")
            .set(this.STEEM_ACCOUNT_NAME, this.steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, this.steemConnectToken)
            .set(this.KEYCHAIN_JWT, this.keychainJWT)
            .send({steemAccountName: this.steemAccountName, currencyType: betCurrency, diceBet})
            .then((res): ServerResponse => {
                return res.body.data;
            }).then((serverResponse) => {
                serverResponse.diceResult.prize = CurrencyDenominator.ToMain(serverResponse.diceResult.prize);
                serverResponse.accountInfo.steemAmount =
                    CurrencyDenominator.ToMain(serverResponse.accountInfo.steemAmount);
                return serverResponse;
            })
            .catch((res) => {
                if (res.status === 402) {
                    InfoModal.open("You need more Hive to keep playing.",
                        "Make a quick deposit and go back to the game!", () => {
                            if (top && top.window) {
                                top.window.location.replace(config.pageAddress);
                            } else {
                                window.location.replace(config.pageAddress);
                            }
                        });
                    InfoModal.setActionButtonText("GO TO MAKING DEPOSIT");
                }
            });
    }

    public initGame(steemAccountName: string, steemConnectToken: string, keychainJWT: string): Promise<AccountInfo> {
        return superagent
            .get(config.gameServerAddress + "/initGame")
            .set(this.STEEM_ACCOUNT_NAME, steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, steemConnectToken)
            .set(this.KEYCHAIN_JWT, keychainJWT)
            .send({})
            .then((res) => {
                this.steemAccountName = steemAccountName;
                this.steemConnectToken = steemConnectToken;
                this.keychainJWT = keychainJWT;
                res.body.data.steemAmount =
                    CurrencyDenominator.ToMain(res.body.data.steemAmount);
                return res.body.data;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/api/ApiService.ts